import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import MailNotification from '../../../types/mail-notification/MailNotification';
import MailNotificationType from '../../../types/mail-notification/MailNotificationType';
import MailStats from '../../../types/mail-notification/MailStats';
import Page from '../../../types/shared/Page';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root',
})
export class MailNotificationService {
    private readonly RESOURCE: string = 'mail-notification';

    constructor(private baseService: BaseService) {
    }

    /**
     * Fetches mail notifications with optional search query and types filter.
     *
     * @param search The search query to filter mail notifications by (optional).
     * @param types The types to filter mail notifications by (optional).
     * @param page The page number to fetch (default: 0).
     * @param size The number of elements per page (default: 10).
     * @return The paginated mail notifications.
     */
    public async getMailNotifications(
        search?: string,
        types?: MailNotificationType[],
        page: number = 0,
        size: number = 10
    ): Promise<Page<MailNotification>> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString());

        if (search) {
            params = params.set('search', search);
        }

        if (types && types.length > 0) {
            params = params.set('types', types.join(','));
        }

        return await this.baseService.get<Page<MailNotification>>(this.RESOURCE, params);
    }

    public async getStats(): Promise<MailStats> {
        return await this.baseService.get<MailStats>(`${ this.RESOURCE }/stats`);
    }

}